(function pickupStoreAvailability() {
  if (!window.jQuery) {
    setTimeout(pickupStoreAvailability, 100);
    return;
  }

  (function ($) {
    "use strict";

    class PickupStoreAvailability extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.buttons = $(this).find("button");
        this.popup = document.querySelector("#Pickup-Availability");
        this.init();
        this.initWatcher();
      }

      init() {
        // Code by Ruby - Convx - TL-3171 - comment it no need active button anymore
        // $(this.buttons?.[0]).addClass("active");
        // End of TL-3171
        this.buttons.on("click", this.handleClick.bind(this));
      }

      handleClick({ target }) {
        const button = $(target).closest("button");
        // Code by Ruby - Convx - TL-3171 - comment it no need active button anymore
        // this.buttons.removeClass("active");
        // button.addClass("active");
        // End of TL-3171

        if (button.data("toggle") == "pickup-availability") {
          $("pickup-availability button")?.click();
        }
      }

      initWatcher() {
        let _ = new ClassWatcher(
          this.popup,
          "active",
          () => {},
          () => {
            $(this.buttons?.[0]).click();
          }
        );
      }
    }

    class ClassWatcher {
      constructor(
        targetNode,
        classToWatch,
        classAddedCallback,
        classRemovedCallback
      ) {
        this.targetNode = targetNode;
        this.classToWatch = classToWatch;
        this.classAddedCallback = classAddedCallback;
        this.classRemovedCallback = classRemovedCallback;
        this.observer = null;
        // Code by Ruby - Convx - TL-3171 - add if condition to avoid error message display
        if(this.classToWatch && targetNode){
          this.lastClassState = targetNode.classList.contains(this.classToWatch);
        }
        // End of TL-3171

        this.init();
      }

      init() {
        this.observer = new MutationObserver(this.mutationCallback.bind(this));
        this.observe();
      }

      observe() {
        // Code by Ruby - Convx - TL-3171 - add if condition to avoid error message display
        if (this.targetNode) {
          this.observer.observe(this.targetNode, { attributes: true });
        }
        // End of TL-3171
      }

      disconnect() {
        this.observer.disconnect();
      }

      mutationCallback(mutationsList) {
        for (let mutation of mutationsList) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            let currentClassState = mutation.target.classList.contains(
              this.classToWatch
            );
            if (this.lastClassState !== currentClassState) {
              this.lastClassState = currentClassState;
              if (currentClassState) {
                this.classAddedCallback();
              } else {
                this.classRemovedCallback();
              }
            }
          }
        }
      }
    }

    if (customElements.get("pickup-store-availability") === undefined) {
      customElements.define(
        "pickup-store-availability",
        PickupStoreAvailability
      );
    }
  })(window.jQuery);
})();
